import { AxiosGetType } from '../../../context/FetchProvider';
import { AxiosPostType } from '../../../context/FetchProvider';
import { BaseQuizRes, QuizItem, RepetitionStats } from '../../../types/quiz';
import { mapResDataToQuizItem } from '../../quiz/mapper';

/**
 * Fetches quiz item data from the provided nodeIDs.
 */
export const getItems = async (
  post: AxiosPostType,
  nodeIDs: number[],
): Promise<QuizItem[]> => {
  const { data } = await post('/v0/questions', { nodeIDs });

  return mapResDataToQuizItem(data as BaseQuizRes);
};

/**
 * Fetches quiz item data from the provided bundleID.
 */
export const getBundle = async (
  get: AxiosGetType,
  bundleID: string,
): Promise<QuizItem[]> => {
  const { data } = (await get('/v0/quiz_bundle', {
    params: {
      bundleID,
      withData: true,
    },
  })) as { data: { data: BaseQuizRes } };

  return mapResDataToQuizItem(data.data as BaseQuizRes);
};

/**
 * Creates a quiz bundle from the provided nodeIDs.
 */
export const createBundle = async (
  post: AxiosPostType,
  nodeIDs: number[],
): Promise<number> => {
  const { data } = await post<{ bundleID: number }, { nodeIDs: number[] }>(
    '/v0/quiz_bundle',
    {
      nodeIDs,
    },
  );

  return data.bundleID;
};

/**
 * Fetches repetition statistics for a given quiz item.
 * Mainly used to retrieve repetition intervals.
 */
export const getRepetitionStats = async (
  get: AxiosGetType,
  nodeID: number,
): Promise<RepetitionStats> => {
  const { data } = await get('/v0/repetition_stats', {
    params: {
      nodeID,
    },
  });

  return data as RepetitionStats;
};

/**
 * Rate a single question node.
 */
export const rateItem = async (
  post: AxiosPostType,
  nodeID: number,
  rating: -1 | 1,
) => {
  await post('/rateitem', {
    nodeID,
    rating,
  });
};
